<div class="add-touchpoint-container">
  <div class="col-1">
    <div class="non-fieldset-section">
      <app-euds-select id="mockDataSelect"
                       label="Prefill with Mock Data:"
                       emptyOptionText="- Select -"
                       [required]="false"
                       [(ngModel)]="selectedMockData"
                       (valueChange)="prefillForm()">
        <app-euds-option slot="option" *ngFor="let mockData of mockDataOptions" [value]="mockData">{{ mockData.name }}</app-euds-option>
      </app-euds-select>
    </div>
    <form #touchpointForm="ngForm" (ngSubmit)="onSubmit(touchpointForm)">
      <fieldset>
        <legend><h6>Core Touchpoint Data</h6></legend>
        <app-euds-textfield id="accountNumber"
                            name="accountNumber"
                            label="Account Number"
                            pattern="^[0-9]*$"
                            [minlength]="accountNumberLength"
                            [maxlength]="accountNumberLength"
                            [(ngModel)]="formModel.accountNumber"
                            [required]="true">
          <span slot="error-pattern">{{accountNumberValidationError}}</span>
          <span slot="error-minlength">{{accountNumberValidationError}}</span>
        </app-euds-textfield>
        <app-euds-button type="secondary" ariaLabel="Add" size="small" icon="feather/refresh-cw" (clickEvent)="generateAccountNumber()" label="Random Account Number"></app-euds-button>


        <app-euds-select id="opco"
                         name="opco"
                         label="OpCo"
                         [required]="true"
                         [(ngModel)]="formModel.opCo"
                         (valueChange)="onOpCoChange($event)"
                         [class.opco-error]="isOpcoInvalid"
                         #opcoSelectControlRef>
          <app-euds-option slot="option"
                           *ngFor="let o of opcoOptions"
                           [value]="o">
            {{ o }}
          </app-euds-option>
        </app-euds-select>

        <app-euds-select id="status"
                         name="status"
                         label="Status"
                         [(ngModel)]="formModel.status"
                         [required]="true">
          <app-euds-option slot="option" *ngFor="let status of touchPointStatusOptions" [value]="status">{{ status }}</app-euds-option>
        </app-euds-select>

        <app-euds-select id="type"
                         name="type"
                         label="Type"
                         [(ngModel)]="formModel.type"
                         [required]="true">
          <app-euds-option slot="option" *ngFor="let type of touchPointTypeOptions" [value]="type">{{ type }}</app-euds-option>
        </app-euds-select>

        <app-euds-select id="channel"
                         name="channel"
                         label="Channel"
                         [(ngModel)]="formModel.channel"
                         [required]="true">
          <app-euds-option slot="option" *ngFor="let channel of interactionChannelOptions" [value]="channel">{{ channel }}</app-euds-option>
        </app-euds-select>

        <app-euds-textfield id="sessionId"
                name="sessionId"
                label="Session ID"
                [(ngModel)]="formModel.sessionId"
                [required]="false">
        </app-euds-textfield>

        <app-euds-date-picker
          id="timestampDate"
          name="timestampDate"
          label="Date Time Stamp"
          dateFormat="mm/dd/yyyy"
          [(ngModel)]="timestampDateOverride"
          (ngModelChange)="onTimestampDateChange()"
          [required]="false">
        </app-euds-date-picker>

        <app-euds-textfield id="target"
                            name="target"
                            label="Target (e.g., URL, Screen)"
                            [(ngModel)]="formModel.target"
                            [required]="false">
        </app-euds-textfield>

      </fieldset>
      <fieldset>
        <legend><h6>Customer Info</h6></legend>
        <app-euds-textfield id="phoneNumber"
                            name="phoneNumber"
                            label="Phone Number"
                            [(ngModel)]="formModel.customerInfo.phoneNumber"
                            [required]="false"> </app-euds-textfield>
        <app-euds-textfield id="customerNumber"
                            name="customerNumber"
                            label="Customer Number"
                            [(ngModel)]="formModel.customerInfo.customerNumber"
                            [required]="false">
        </app-euds-textfield>
        <div *ngFor="let premiseId of formModel.customerInfo.premiseIds || []; let i = index">
          <app-euds-textfield [name]="'premiseId' + i"
                              [label]="'Premise ID'"
                              [ariaLabel]="'Premise ID ' + (i + 1)"
                              [(ngModel)]="formModel.customerInfo.premiseIds[i]"
                              [required]="false">
          </app-euds-textfield>
        </div>
        <app-euds-button type="secondary"
                         size="small"
                         label="Add Premise ID"
                         (clickEvent)="addPremiseId()"></app-euds-button>
      </fieldset>
      <fieldset>
        <legend><h6>Processing Context</h6></legend>
        <app-euds-autocomplete #autocompleteProduct
                               id="product"
                               name="product"
                               label="Product"
                               [required]="false"
                               [hideIcon]="true"
                               [forceSelection]="false"
                               [useCustomFilter]="true"
                               [showOptionsOnInputFocus]="true"
                               [options]="optionsProduct"
                               [(ngModel)]="formModel.processingContext.product"
                               (textEnteredEvent)="productTextEntered($event)"
                               (valueChange)="productValueChange($event)"
                               (clearEvent)="productClearEvent($event)">
        </app-euds-autocomplete>
        <app-euds-autocomplete #autocompleteJourney
                               id="journey"
                               name="journey"
                               label="Journey"
                               [required]="false"
                               [hideIcon]="true"
                               [forceSelection]="false"
                               [useCustomFilter]="true"
                               [showOptionsOnInputFocus]="true"
                               [options]="optionsJourney"
                               [(ngModel)]="formModel.processingContext.journey"
                               (textEnteredEvent)="journeyTextEntered($event)"
                               (valueChange)="journeyValueChange($event)"
                               (clearEvent)="journeyClearEvent($event)">
        </app-euds-autocomplete>
        <app-euds-autocomplete #autocompleteStep
                               id="step"
                               name="step"
                               label="Step"
                               [required]="false"
                               [hideIcon]="true"
                               [forceSelection]="false"
                               [useCustomFilter]="true"
                               [showOptionsOnInputFocus]="true"
                               [options]="optionsStep"
                               [(ngModel)]="formModel.processingContext.step"
                               (textEnteredEvent)="stepTextEntered($event)"
                               (valueChange)="stepValueChange($event)"
                               (clearEvent)="stepClearEvent($event)">
        </app-euds-autocomplete>
        <app-euds-textfield id="resultCode"
                            name="resultCode"
                            label="Result Code"
                            [(ngModel)]="formModel.processingContext.resultCode"
                            [required]="false">
        </app-euds-textfield>
        <app-euds-textfield id="resultDescription"
                            name="resultDescription"
                            label="Result Description"
                            [(ngModel)]="formModel.processingContext.resultDescription"
                            [required]="false">
        </app-euds-textfield>
        <app-euds-textarea id="extensionData"
                           name="extensionData"
                           label="Extension Data (JSON)"
                           class="margin-top-3"
                           [(ngModel)]="formModel.processingContext.extensionData"
                           [required]="false">
        </app-euds-textarea>
      </fieldset>

      <fieldset>
        <legend><h6>Technical Dependency</h6></legend>
        <app-euds-textfield id="service"
                            name="service"
                            label="Service"
                            [(ngModel)]="formModel.dependency.service"
                            [required]="false">
        </app-euds-textfield>
        <app-euds-textfield id="operation"
                            name="operation"
                            label="Operation"
                            [(ngModel)]="formModel.dependency.operation"
                            [required]="false">
        </app-euds-textfield>
        <app-euds-textfield id="endpoint"
                            name="endpoint"
                            label="Endpoint"
                            [(ngModel)]="formModel.dependency.endpoint"
                            [required]="false">
        </app-euds-textfield>
        <app-euds-textfield id="httpStatusCode"
                            name="httpStatusCode"
                            label="HTTP Status Code"
                            type="text"
                            mask="000"
                            [(ngModel)]="formModel.dependency.httpStatusCode"
                            [required]="false">
        </app-euds-textfield>
      </fieldset>

      <div>
        <app-euds-textarea id="additionalInfo"
                           name="additionalInfo"
                           label="Additional Info (Text or JSON)"
                           class="margin-top-3"
                           [(ngModel)]="formModel.additionalInfo"
                           [required]="false">
        </app-euds-textarea>
      </div>
    </form>
  </div>
  <div class="col-2 json-preview">
    <app-euds-button class="json-copy-btn" type="plain" ariaLabel="Copy JSON" icon="feather/copy" (clickEvent)="copyJson()"></app-euds-button>
    <span *ngIf="copyStatusMessage" class="copy-status-message">{{ copyStatusMessage }}</span>
    <h3>Touchpoint Preview:</h3>
    <pre [innerHTML]="prettyPrintJson"></pre>
  </div>
</div>
